/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface DeploymentDeletionSpec { 
    /**
     * Approve deletion (applicable if Deployment is in Approval pending state)
     */
    approve_deletion?: boolean;
    /**
     * Force delete Deployment object from DB (STG only)
     */
    force_delete?: boolean;
    /**
     * Org id
     */
    org_id: string;
    /**
     * Skip deleting shadow account resources during deactivation.
     */
    skip_resource_deletion?: boolean;
    type: ServiceTypeEnum;
}
export namespace DeploymentDeletionSpec {
}


